import { formatDate } from "../../utils/formatting";
import { roleLabel } from "../../utils/companyUserRole";

export function normaliseUsername(username) {
	return (username ?? "").trim().toLowerCase();
}

export function getTodayDateString() {
	const today = new Date();
	const day = String(today.getDate()).padStart(2, "0");
	const month = String(today.getMonth() + 1).padStart(2, "0");
	const year = today.getFullYear();

	return `${day}/${month}/${year}`;
}

export function mapLoadedUserToRow(user) {
	return {
		...user,
		RowKey: `db-${user.Id}`,
		IsPendingCreate: false
	};
}

export function mapPendingUserToRow(user) {
	const tempKey = `tmp-${crypto.randomUUID()}`;

	return {
		...user,
		Id: null,
		RowKey: tempKey,
		IsPendingCreate: true
	};
}

export function mapCompletedPendingUserRow(existingRow, newId) {
	return {
		...existingRow,
		Id: Number(newId),
		RowKey: `db-${Number(newId)}`,
		IsPendingCreate: false,
		LastReminderDate: getTodayDateString()
	};
}

export function getUserFullName(user) {
	if (!user) {
		return "";
	}

	const firstName = (user.FirstName ?? "").trim();
	const lastName = (user.LastName ?? "").trim();

	return [firstName, lastName].filter(Boolean).join(" ");
}

export function getAccessLevelLabel(rowData) {
	const idNum = Number(rowData?.RoleId);
	const label = roleLabel(idNum);

	if (label && label !== String(idNum)) {
		return label;
	}

	return rowData?.RoleName ?? "";
}

export function getLastLoginDisplayValue(rowData) {
	if (rowData?.IsPendingCreate) {
		return <span className="processing-shimmer">Processing</span>;
	}

	const dateString = rowData?.LastLoginDate;

	if (!dateString) {
		return "Not logged in";
	}

	const date = new Date(dateString);

	if (isNaN(date)) {
		return "Not logged in";
	}

	return formatDate(dateString);
}

export function mapUserToBaseRequestBody(user) {
	return {
		FirstName: (user?.FirstName ?? "").trim(),
		LastName: (user?.LastName ?? "").trim(),
		Username: (user?.Username ?? "").trim(),
		RoleId: Number(user?.RoleId)
	};
}

export function mapAddUserRequestBody(user, companyId, signalRGroupName) {
	return {
		...mapUserToBaseRequestBody(user),
		CompanyId: Number(companyId),
		Id: -1,
		SignalRGroupName: signalRGroupName
	};
}

export function mapUpdateUserRequestBody(user, companyId) {
	return {
		...mapUserToBaseRequestBody(user),
		CompanyId: Number(companyId),
		Id: Number(user?.Id)
	};
}

export function mapDeleteUserRequestBody(user) {
	return {
		...mapUserToBaseRequestBody(user),
		Id: Number(user?.Id)
	};
}

export function mapUserToCleanUser(user) {
	return {
		...user,
		FirstName: (user?.FirstName ?? "").trim(),
		LastName: (user?.LastName ?? "").trim(),
		Username: (user?.Username ?? "").trim(),
		RoleId: Number(user?.RoleId)
	};
}